import React, { useMemo } from "react";
import styled from "styled-components";
import Colors from "../../../styles/Colors";
import { SmallRegular } from "../../../styles/Fonts";
import usdc from "../../../images/usdc.png";
import { PoolProps } from "../../../utils/constant/pools";
import useUserPoolSupply from "../../../hooks/useUserPoolSupply";

const PoolBalanceItem: React.FC<{ pool: PoolProps }> = ({ pool }) => {
  const { tokenSymbol, lendingPoolAddress } = pool;

  const {
    depositedAmount,
    withdrawnAmount,
    shares,
    estimatedExchangeRate,
    earned,
    balance,
  } = useUserPoolSupply(lendingPoolAddress);

  const roi = useMemo(
    () =>
      depositedAmount &&
      (
        ((shares * estimatedExchangeRate -
          (depositedAmount - withdrawnAmount)) /
          depositedAmount) *
        100
      ).toFixed(6),
    [shares, estimatedExchangeRate, depositedAmount, withdrawnAmount]
  );

  return (
    <PortfolioTokenRow>
      <TokenRow>
        <TokenIconSm src={pool.tokenUrl} />
        <ValueText>{pool.tokenSymbol}</ValueText>
      </TokenRow>
      <Row>
        <MLabel>ROI</MLabel>
        <ValueText>{roi} %</ValueText>
      </Row>
      <Row>
        <MLabel>Balance</MLabel>
        <ValueText>{`${balance} ${tokenSymbol}`}</ValueText>
      </Row>
      <Row>
        <MLabel>Earned</MLabel>
        <ValueText>{`${earned} ${tokenSymbol}`}</ValueText>
      </Row>
    </PortfolioTokenRow>
  );
};

export default PoolBalanceItem;

const TokenRow = styled.div`
  flex: 0 0 200px;
  display: flex;
  align-items: center;
  @media (max-width: 768px) {
    flex: inherit;
    width: 100%;
    align-items: flex-start;
    margin-bottom: 12px;
  }
`;

const PortfolioRow = styled.div`
  display: grid;
  grid-template-columns: 100px repeat(3, 1fr);
  align-items: center;
  > span:not(:first-child) {
    text-align: right;
  }
`;

const PortfolioTokenRow = styled(PortfolioRow)`
  padding: 24px 40px 24px 24px;
  background-color: ${Colors.backgroundGray4};
  border-radius: 8px;
  margin-top: 16px;
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    grid-template-columns: 1fr;
    padding: 20px;
  }
`;

const ValueText = styled(SmallRegular)`
  color: ${Colors.ivory};
  font-size: 14px;
  @media (max-width: 768px) {
    text-align: right;
    font-size: 13px;
    line-height: 18px;
  }
`;

const TokenIconSm = styled.img`
  height: 24px;
  margin-right: 12px;
  @media (max-width: 768px) {
    height: 20px;
    margin-right: 8px;
  }
`;

const Row = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  @media (max-width: 768px) {
    justify-content: space-between;
    padding: 4px 0;
  }
`;

const MLabel = styled(ValueText)`
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
`;
